<template>
  <div class="main">
    <div class="top-nav" :style="{ background: navBack }">
      <div class="top-ul">
        <div class="li" v-for="(item, index) in navData" @click="topNavTap(item)">
          <span :style="{color:pc_font_color}">{{ item.name }}</span>
        </div>
        <div class="li collect" @click="_addFavorite">
          <span :style="{color:pc_font_color}">
            <i class="el-icon-star-off"></i>
            收藏本站</span>
        </div>
      </div>
      <div class="code-phone">
        <el-popover placement="top-start" width="180" trigger="hover">
          <div class="code-img">
            <img src="/static/index/code-logo.png" alt="" />
          </div>
          <!-- <el-button ></el-button> -->
          <div slot="reference" class="code-text" :style="{color:pc_font_color}">手机端购买</div>
        </el-popover>
      </div>

    </div>

    <div class="logo-search">
      <div class="logo-left">
        <div class="logo" @click="homeClick">
          <img :src="configObj.pc_logo" alt="" v-if="configObj.pc_logo" />
        </div>
        <div class="pc_name" :style="{color:configObj.pc_name_color}">
          {{configObj.pc_name}}
        </div>

      </div>
      <div class="search">
        <el-input placeholder="请输入关键字/商品名称" v-model="searchValue" class="input-with-select">
          <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option label="餐厅名" value="1"></el-option>
            <el-option label="订单号" value="2"></el-option>
            <el-option label="用户电话" value="3"></el-option>
          </el-select> -->
          <el-button slot="append" icon="el-icon-search" @click="searchTap"></el-button>
        </el-input>
      </div>
    </div>



  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        navData: [{
          name: "首页",
          src: "/"
        }],
        categoryData: [],
        configObj: {},
        searchValue: "",
        navBack: "#333333",
        pc_font_color: "#FFFFFF"
      }
    },
    mounted() {
      this.getConfig()
    },
    methods: {
      _addFavorite() {
        var url = window.location;
        var title = document.title;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("360se") > -1) {
          alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
        } else if (ua.indexOf("msie 8") > -1) {
          window.external.AddToFavoritesBar(url, title); //IE8
        } else if (document.all) { //IE类浏览器
          try {
            window.external.addFavorite(url, title);
          } catch (e) {
            alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
          }
        } else if (window.sidebar) { //firfox等浏览器；
          window.sidebar.addPanel(title, url, "");
        } else {
          alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
        }
      },
      homeClick() {
        this.$router.push({
          path: "/",
        })
      },
      getConfig() {
        this.$http.post('?s=/apiPc.Index/config')
          .then(response => {
            this.configObj = response.data.sysset;
            this.navBack = this.configObj.pc_theme_color ? this.configObj.pc_theme_color : "";
            this.pc_font_color = this.configObj.pc_font_color ? this.configObj.pc_font_color : "";
          })
          .catch(error => {});
      },
      searchTap() {
        this.$router.push({
          path: "/pages/shop/prolist",
          query: {
            keyword: this.searchValue,
            name: this.searchValue
          }
        })
      },
      topNavTap(item) {
        this.$router.push({
          path: item.src,
          // query: {
          //   id: item.id
          // }
        })
      }
    }
  }
</script>

<style scoped>
  .main {
    background: #f5f5f5;
  }

  .logo-search {
    padding: 12px 123px 12px 123px;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    /* justify-content: space-between; */
  }

  .logo-search .logo-left {
    display: flex;
    align-items: flex-end;
  }

  .logo-search .logo-left .pc_name {
    font-size: 18px;
  }

  .logo-search .logo {
    width: 192px;
    height: 100px;
    cursor: pointer;
    margin-right: 10px;
  }

  .logo-search .search {
    width: 400px;
    padding-left: calc(50% - 380px);
  }

  .logo-search .search .input-with-select {
    border-radius: 0;
    /* line-height: 84px; */
    /* height: 84px; */
  }

  .logo-search .search .el-icon-search {
    border-radius: 0;
  }

  .main .top-nav {
    padding: 0 123px 0 123px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .main .top-nav .code-phone .code-img {
    width: 180px;
    height: 180px;
  }

  .main .top-nav .code-phone .code-text {
    font-size: 12px;
    line-height: 40px;
    /* color: #b0b0b0; */
    cursor: pointer;
    user-select: none;
  }

  .main .top-nav .collect i {
    font-size: 14px;
    transform: translateY(1px);
  }

  .top-ul {
    display: flex;
    align-items: center;
  }

  .main .top-nav .li {
    font-size: 12px;
    line-height: 40px;
    /* color: #b0b0b0; */
    cursor: pointer;
    user-select: none;
  }

  .main .top-nav .li span {
    border-right: 1px solid #b0b0b0;
  }

  .main .top-nav .li span {
    padding: 0 10px;
    line-height: 10px;
    display: inline-block;
  }

  .main .top-nav .li:first-child span {
    padding-left: 0;
  }

  .main .top-nav .li:last-child span {
    border: none;
  }


  .main .top-nav .li:hover {
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/headers/index.vue